var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowthick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 264.5 264.5",
    style: {
      enableBackground: "new 0 0 264.5 264.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010002;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.4,39.4c2,0,3.9,1.1,4.9,3c0.3,0.6,25.2,46.8,129.3,48.4v-46c0-2.1,1.2-4,3-4.9c1.9-0.9,4.1-0.7,5.7,0.6 l114,87.4c1.3,1,2.1,2.6,2.1,4.3c0,1.7-0.8,3.3-2.1,4.3l-114,87.4c-1.6,1.3-3.9,1.5-5.7,0.6c-1.9-0.9-3-2.8-3-4.9v-48.5 c-2.8,0.2-6.3,0.3-10.6,0.3C90.2,171.5,0,159.2,0,44.9c0-2.5,1.7-4.7,4.2-5.3C4.6,39.5,5,39.4,5.4,39.4z M250.1,132.2l-99.6-76.3 v40.4c0,3-2.4,5.4-5.4,5.4c-79.2,0-117-24.2-133.4-40.4c8.3,89.2,83.9,99.2,117.4,99.2c9.3,0,15.2-0.8,15.3-0.8 c1.6-0.2,3.1,0.3,4.3,1.3c1.2,1,1.9,2.5,1.9,4.1v43.4L250.1,132.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowthick);
export default __webpack_public_path__ + "static/media/arrowthick.1284b540fc20027bac88c01aa021f683.svg";
export { ForwardRef as ReactComponent };